import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {BaseService} from '../common/base.service';
import {Stock} from './stock';
import {PotStock} from './pot/pot';
import {catchError} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class StockService extends BaseService {

  private apiUrl = this.baseUrl + '/stock';

  updateStock(stock: Stock): Observable<Stock> {
    return this.http.put<Stock>(this.apiUrl + '/' + stock.id, stock);
  }

  splitStock(stockId: number, splitAmount: number, amountFitForSale: number, location?: string, remark?: string, version?: number,
             reservedStockIds?: number[]) {
    return this.http.patch<PotStock>(
      `${this.apiUrl}/split`,
      {
        stockId: stockId,
        splitAmount: splitAmount,
        amountFitForSale: amountFitForSale,
        location: location,
        remark: remark,
        version: version,
        reservedStockIds: reservedStockIds,
      }
    );
  }

  getStockById(id: number): Observable<Stock> {
    return this.http.get<Stock>(this.apiUrl + '/' + id)
      .pipe(catchError(this.handleError('ophalen van voorraadpartij', undefined,
        'Fout bij ophalen van voorraad met id ' + id)));
  }
}
